import { Component, inject, Inject, Input } from '@angular/core';
import { MasterService } from '../../core/services/master.service';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckDouble, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
//import { TranslateModule } from '@ngx-translate/core';
//import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-btn',
  imports: [CommonModule,FontAwesomeModule],
  templateUrl: './btn.component.html',
  styleUrl: './btn.component.scss',
})
export class BtnComponent {
  faIcon=faWhatsapp;
  faWhatsapp=faWhatsapp;
  faCheck=faCheckDouble;
  faMapMarker=faMapMarkerAlt;

  l_class = "btn";
  l_icon = false;
  l_external = false;  
  l_target = "";
  public l_txt = ""; 

  _svc_master = inject(MasterService);
  //_svc_translate = inject(TranslateService);

  @Input() i_type!:string;
  @Input() i_destiny!:string;
  @Input() i_label!:string;

  ngOnInit() {
    this.l_class = "btn " + this.i_type;

    this.l_txt = this.i_label.toString();

    if (this.i_destiny)
      this.l_external = this.i_destiny.indexOf("octa") >= 0 || this.i_destiny.indexOf("whatsapp") >= 0 || this.i_destiny.indexOf("map") >= 0;

    switch(this.i_destiny) {
      case "whatsapp":
        this.l_target = "https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, NewFight! Gostaria de saber mais sobre o Performance Club.";
        this.l_icon = true;
        this.faIcon = this.faWhatsapp;
        break;

      case "maps":
        this.l_target = "https://www.google.com/maps/dir//New+Fight+Performance+Club+%7C+Academia+de+artes+Marciais+%7C+Muay+Thai+-+Jiu-Jitsu+-+Boxe+-+Funcional+Fight+-+R.+Casa+do+Ator,+1100+-+Vila+Ol%C3%ADmpia,+S%C3%A3o+Paulo+-+SP,+04546-004/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x94ce5716c43024c3:0xce37a9f7e63c20af?sa=X&ved=1t:57443&ictx=111";
        this.l_icon = true;
        this.faIcon = this.faMapMarker;
        break;

      case "register":
        this.l_icon = true;
        this.faIcon = this.faCheck;
        break;

      case "arena":
        this.l_class = "btn primary-line";
        this.l_icon = false;
        break;

      case "gallery":
        this.l_class = "btn primary-line";
        this.l_icon = false;
        break;

      case "skill":
        this.l_class = "btn primary-txt";
        this.l_icon = false;
        break;

      default:
        this.l_icon = false;
        break;
    }

  }

  trg_btn() {
    this._svc_master.navigate(this.i_destiny);
  }
  
}
